import { Link } from '../../i18n/navigation'
import { forwardRef, type ComponentProps, type ForwardedRef } from 'react'
import { Button, type ButtonProps } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'

type ButtonLinkProps = Omit<ButtonProps, 'href'> &
  ComponentProps<typeof Link> & {
    buttonClassName?: string
  }

export const ButtonLink = forwardRef(function ButtonLink(
  props: ButtonLinkProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  const {
    children,
    href,
    replace,
    target,
    locale,
    scroll,
    prefetch,
    type,
    className,
    buttonClassName,
    ...buttonProps
  } = props
  return (
    <Link
      href={href}
      locale={locale}
      prefetch={prefetch}
      replace={replace}
      target={target}
      scroll={scroll}
      className={cn('inline-flex', className)}
    >
      <Button
        {...buttonProps}
        type={type}
        variant={buttonProps.variant || 'transparent'}
        ref={ref}
        className={buttonClassName}
      >
        {children}
      </Button>
    </Link>
  )
})

ButtonLink.displayName = 'ButtonLink'
